import {
  SALE_DURATION_OPTIONS,
  formatDurationLabel,
  saleEndDate,
} from './saleDurationUtils';

export default function SaleDurationField({
  idPrefix,
  duration,
  startDate,
  endDate,
  onPeriodChange,
  durationOptions = SALE_DURATION_OPTIONS,
}) {
  const computedEnd = startDate ? saleEndDate(startDate, duration) : '';
  const displayEnd = endDate || computedEnd;
  const selectedLabel = formatDurationLabel(duration, durationOptions);

  return (
    <>
      <div className="owner-form-group">
        <label className="owner-form-label" htmlFor={`${idPrefix}-duration`}>
          Duration
        </label>
        <select
          id={`${idPrefix}-duration`}
          name="duration"
          className="owner-form-select"
          value={duration}
          onChange={onPeriodChange}
          required
        >
          {durationOptions.map(({ value, label }) => (
            <option key={value} value={value}>{label}</option>
          ))}
        </select>
        <p className="owner-placeholder-text rec-sale-payment-hint">
          {selectedLabel}
        </p>
      </div>

      <div className="owner-form-group">
        <label className="owner-form-label" htmlFor={`${idPrefix}-start-date`}>
          Start Date
        </label>
        <input
          id={`${idPrefix}-start-date`}
          name="startDate"
          type="date"
          className="owner-form-input"
          value={startDate}
          onChange={onPeriodChange}
          required
        />
      </div>

      <div className="owner-form-group">
        <label className="owner-form-label" htmlFor={`${idPrefix}-end-date`}>
          End Date
        </label>
        <input
          id={`${idPrefix}-end-date`}
          name="endDate"
          type="date"
          className="owner-form-input rec-add-package-input-readonly"
          value={displayEnd}
          readOnly
          tabIndex={-1}
          aria-readonly="true"
        />
        <p className="owner-placeholder-text rec-sale-payment-hint">
          Auto-calculated from start date and duration.
        </p>
      </div>
    </>
  );
}
